import { snakeStore, DATA } from '@app/plugins/vuex-async-pagginate';
import { StatService } from '@phone-number/services/StatService';

export const general = snakeStore(
  {
    actions: {
      getData: ({ commit }, params) => {
        return StatService.getGeneral(params).then((response) => {
          if (Array.isArray(response.data)) {
            commit(DATA, response.data);
            return response.data;
          } else {
            let modify_data = Object.keys(response.data)?.sort().map((key) => {
              return { group_by: key, ...response.data[key] };
            });

            modify_data = [
              ...modify_data,
              {
                group_by: 'total',
                number_count: response.total_number_count,
                average_subscription_fee: response.total_average_subscription_fee,
                connection_cost_sum: response.total_connection_cost_sum,
                subscription_fee_sum: response.total_subscription_fee_sum
              }
            ];

            commit(DATA, modify_data);
          }
        });
      }
    }
  },
  true
);
